export interface AssistantStatusEvent {
  status: AssistantStatusEventActionEnum;
  assistantPopoverListChanged?: boolean;
}

export enum AssistantStatusEventActionEnum {
  DISABLED,
  ENABLED
}
